Vue.component('review-page', {
    props: {
        productId: Number
    },
    data() {
        return {
            formIsOpen: false,
            page: 1,
            hasMoreReviews: true,
            form: {
                name: '',
                text: '',
                rate: 5,
            },
            reviews: [],
        };
    },
    methods: {
        openForm() {
            this.formIsOpen = true;
        },
        closeForm() {
            this.formIsOpen = false;
        },
        getReviews() {
            let _this = this;
            axios.get('/api/reviews', {
                params: {
                    page: _this.page++,
                    product_id: _this.productId,
                }
            }).then(function (response) {
                if (response.data.success) {
                    _this.reviews.push(...response.data.reviews);
                    _this.hasMoreReviews = !response.data.isEnd;
                }
            });
        },
        sendForm(e){
            e.preventDefault();
            let data = JSON.parse(JSON.stringify(this.form));
            CsrfHelper.addCsrf(data);
            data.product_id = this.productId;

            let _this = this;
            axios.post('/api/send-review', data).then(function (response) {
                if (response.data.success) {
                    _this.form.rate = 5;
                    _this.form.name = "";
                    _this.form.text = "";
                    alert('Ваш отзыв принят');
                } else {
                    alert(response.data.error);
                }
            });
        },
        changeReviewRating: function (newRating) {
            this.form.rate = newRating;
        }
    },
    created() {
        this.getReviews();
    },
});